// extracted by mini-css-extract-plugin
export default {"colorsContainer":"carsColors_colorsContainer__TmjtF","colorBtn":"carsColors_colorBtn__dIXZi"};